import { render, staticRenderFns } from "./blank-space.vue?vue&type=template&id=04720046"
import script from "./blank-space.vue?vue&type=script&lang=js"
export * from "./blank-space.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports